import { RelevanceReq, RelevanceDef } from "../type/relevance-def";

export class RelevanceAdapter {
  static toInputDTO(req: RelevanceReq): any {
    return {
      is_past_look: true,
      outcome_node: req.outcome_node,
      ...(req.strat_node ? { strat_node: req.strat_node } : {}),
      // 未指定のときは送らない (既存の呼び出し元の挙動を変えないため)。
      ...(req.is_smallytics === undefined
        ? {}
        : { is_smallytics: req.is_smallytics }),
    };
  }

  static toOutputDTO(res: any): RelevanceDef {
    return res;
  }
}
